// Plugins
import { registerPlugins } from '@/plugins';
import { createI18n } from 'vue-i18n';
import es from '@/locales/es.json';
import en from '@/locales/en.json';
import VueTheMask from 'vue-the-mask';
import { createApp } from 'vue';
// Components
import App from './App.vue';

// Composables

const app = createApp(App);

registerPlugins(app);

const i18n = createI18n({
  legacy: false,
  locale: 'Español',
  missingWarn: false,
  fallbackWarn: false,
  silentTranslationWarn: true,
  messages: {
    Español: es,
    English: en,
  },
});

app.config.globalProperties.$filters = {
  toCurrency(value, currency = 'USD') {
    if (typeof value !== 'number') {
      return value;
    }
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    });
    if (currency === 'USD') {
      return currency + formatter.format(value);
    }
    return formatter.format(value);
  },
};

app.use(i18n);
app.use(VueTheMask);

app.mount('#app');
